import React, { useMemo } from 'react';

import { useHistory, useParams } from 'react-router';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Container, Stack, Typography } from '@mui/material';

import useQuery from '~/hooks/useQuery';

import ExistingScheduleForm from '../Components/ExistingScheduleForm';
import NewScheduleForm from '../Components/NewScheduleForm';
import { SCHEDULE_SEARCH_PARAMS_STORAGE_KEY } from '../Components/SchedulesFilters';

function HeroPlannerScheduleEditorPage() {
  const history = useHistory();
  const searchParams = useQuery();
  const isDuplicate = searchParams.get('duplicate');
  const segment = searchParams.get('segment');
  const { scheduleEditorId } = useParams<{
    scheduleEditorId: string | 'new';
  }>();

  const { scheduleId, editorType } = useMemo(() => {
    if (scheduleEditorId === 'new') {
      return { editorType: 'new' as const, scheduleId: undefined };
    }

    if (isDuplicate) {
      return { editorType: 'duplicate' as const, scheduleId: scheduleEditorId };
    }

    return {
      editorType: 'existing' as const,
      scheduleId: scheduleEditorId,
    };
  }, [scheduleEditorId, isDuplicate]);

  const handleBack = () => {
    const storedParams = localStorage.getItem(SCHEDULE_SEARCH_PARAMS_STORAGE_KEY);
    const url = storedParams
      ? `/customer-communication/hero-planner/schedules?${storedParams}`
      : '/customer-communication/hero-planner/schedules';
    history.push(url);
  };

  return (
    <Container>
      <Stack direction="column" gap={4}>
        <Stack direction="row" alignItems="center" gap={1}>
          <Button onClick={handleBack} startIcon={<ArrowBackIcon />} variant="text">
            Back to schedules
          </Button>
        </Stack>
        <Typography variant="h3">
          {editorType === 'new' && 'Create new schedule'}
          {editorType === 'duplicate' && 'Create schedule from duplicate'}
          {editorType === 'existing' && 'Update existing schedule'}
        </Typography>
        {(editorType === 'new' || editorType === 'duplicate') && (
          <NewScheduleForm scheduleId={scheduleId} segment={segment} editorType={editorType} />
        )}
        {editorType === 'existing' && <ExistingScheduleForm scheduleId={scheduleId} segment={segment} />}
      </Stack>
    </Container>
  );
}

export default HeroPlannerScheduleEditorPage;
